export const priceData = [
  {
    name: "Летний бассейн",
    title: "Выходные дни",
    li: "• Взрослые (с 10 лет) :<span>500р</span>, <span>1 700р</span>/день ",
    li2: "• Дети (с 5 до 10 лет): <span>350р</span>/час; <span>900р</span>/день",
    li2Span: "",
    li2Span2: "",
    title2: "Будние дни",
    li3: "• Взрослые (с 10 лет): <span>500р</span>/час, <span>1 500р</span>/день",
    li4: "• Дети (с 5 до 10 лет): <span>350р</span>/час, <span>700р</span>/день",
    footerClass: "footerClass",
    li5: "• Беседка малая <span>2 500р</span>",
    li6: "• Беседка большая <span>3 000р</span>",
    li7: "• Шатер <span>2000р</span>",
    li8: "• Шатер Большой <span>12 000р</span>",
    link: "/waterpool",
    id: "One",
  },
  {
    name: "Гостиничные номера",
    li: "• <span>3 000р-4500</span>/сутки",
    li2: "• <span>4 500р</span> /Домик на летней территории\n",
    li3: "• <span>5 000р</span> /Апартаменты на летней территории\n",
    link: "/rooms",
    id: "Two",
  },
  {
    name: "Сауна №1",
    li: "• цена рассчитана на 10 человек: <span>2 200р</span>/час;",
    li2: "• Если количество человек превышает вместимость зала, то дополнительное место оплачивается из расчета <span>200р</span>/час",
    link: "/sauna",
    id: "Three",
  },
  {
    name: "Русская баня на дровах №1",
    orangeClass: "orangeText",
    orangeText:
      "При посещении бани более чем на 5 часов, парение в Сибирском чане в подарок!",
    li: "• Русская баня <span>2 800р</span>/час",
    li2: "• Веники (дубовый и эвкалипт) <span>300-380р</span>",
    li3: "• Самовар на дровах <span>450р</span>",
    li4: "• Сибирский чан <span>3 500р</span>",
    link: "/russianSauna",
    id: "Four",
  },
  {
    name: "Хамам",
    li: "• цена рассчитана на 10 человек: <span>2 900р</span>/час",
    li2: "• Если количество человек превышает вместимость зала, то дополнительное место оплачивается из расчета <span>200р</span>/час",
    link: "/hamam",
    id: "Five",
  },
  {
    name: "Хамам 2",
    li: "• <span>3 200р</span>/час будние дни",
    li2: "• <span>3 900р</span>/час выходные и праздничные дни",
    link: "hamam2",
    id: "Six",
  },
  {
    name: "Сауна №2",
    li: "• цена рассчитана на 10 человек: <span>2 500р</span>/час",
    li2: "• Если количество человек превышает вместимость зала, то дополнительное место оплачивается из расчета <span>200р</span>/час",
    link: "sauna2",
    id: "Seven",
  },
  {
    name: "Номер с финской парной и джакузи",
    li: "• цена рассчитана на 5 человек:  <span>1500р</span>/час",
    link: "finnishRoom",
    id: "Eight",
  },
  {
    name: "Русская баня на дровах №2",
    orangeClass: "orangeText",
    orangeText:
      "При посещении бани более чем на 5 часов, парение в Сибирском чане в подарок!",
    li: "•  Час <span>2 900р</span>",
    li2: "• Будние дни <span>19 000р</span>",
    li3: "• Пятница, суббота, Воскресенье <span>23 000р</span>",
    li4: "• До <span>15</span> человек входит в стоимость",
    link: "/russianBathhouse",
    id: "Nine",
  },
  {
   name: "Банкетный зал",
   li: "• Аренда зала <span>70,000р</span>",
    li2: "• Профессиональная команда наших партнеров“Family catering” обеспечит высокий уровень сервиса, предлагая разнообразное меню и индивидуальный подход к каждому событию.",
    link: "/hall",
    id: "Ten",
  }

];
